export default __webpack_public_path__ + "static/media/defaultShareProject.87e21ac3.png";